module.exports = __webpack_public_path__ + "img/solution25.99e006f9.png";